// ==========================================================================
// Bootstrap 4 Helpers for WeLearn Pro Player
//
// Copyrights 2019 Wewasanad Co.,Ltd.
// ==========================================================================


/**
 * Class consists of quick Bootstrap functions designed for WeLearn Pro Player
 */
export default class Bootstrap4Helper {
    /**
     * Create alert below the video player.
     * @param message - Alert message. Can be in normal string format or HTML.
     * @param timeout - Time to close alert in seconds.
     * @param element - Specify what element that alert will be inserted below (Default: insert below wlpVideo__progress-bar)
     */
    static invokeAlert(message, timeout, element = '.wlpVideo__progress-bar') {
        if ($('#wlpAlert').length) {
            $('#wlpAlert').alert('close');
        }

        $(element).after(`<div id="wlpAlert" class="alert alert-danger alert-dismissible fade show" role="alert">${message}<button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button></div>`);

        if (typeof timeout !== 'undefined') {
            setTimeout(function () {
                $('#wlpAlert').alert('close');
            }, timeout);
        }
    }
}